import { z } from "zod";
import { userProfileSchema } from "./user";
import { levelProgressSchema, streakSummarySchema } from "./progression";
import { missionSchema, activityEventSchema } from "./social";
import { gameCatalogueEntrySchema, announcementSchema } from "./config";

/**
 * GET /api/v1/home — everything the Home/lobby screen needs in one
 * request, so mobile doesn't fire off eight separate round trips.
 * Deliberately scoped to Home's needs, not an unlimited mega-endpoint.
 */
export const homeResponseSchema = z.object({
  profile: userProfileSchema,
  wallet: z.object({ balance: z.number().int() }),
  progression: levelProgressSchema,
  dailyReward: z.object({
    amountCredits: z.number().int(),
    amountXp: z.number().int(),
    claimedToday: z.boolean(),
  }),
  streak: streakSummarySchema,
  missions: z.array(missionSchema),
  featuredGames: z.array(gameCatalogueEntrySchema),
  /** Null when presence couldn't be read (e.g. DO temporarily unavailable) — not a hard dependency for Home to render. */
  onlineCount: z.number().int().nullable(),
  recentActivity: z.array(activityEventSchema),
  announcement: announcementSchema.nullable(),
});

export type HomeResponse = z.infer<typeof homeResponseSchema>;
